import api from 'lib/trpcClient';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

function useListPendingAdvisedForFund(fundId?: string) {
  return api.incompleteInvestment.listPendingAdvisedForFund.useQuery(
    { fundId: fundId || '' },
    {
      enabled: !!fundId,
      staleTime: QUERY_STALE_TIME_MS,
    },
  );
}

export default useListPendingAdvisedForFund;
